import React from "react";
import { Menu, MenuItem } from '@szhsin/react-menu'
// import { fullName } from "@modules/form-wizard/utils";
import { getUploadPath } from "@modules/form-wizard/utils";

const BatchFormView = ({ methods, setFormSelected, passedProps, allFields }) => {
  const { service, formSelected, } = passedProps;

  const populateUploads = (certsOnly = false) => (
    formSelected?.image?.map((data, index) => {
      const dataSplit = data.split('/');
      const isMissing = dataSplit[1] != 'system';
      let uploadName = isMissing ? dataSplit[1] : dataSplit[3];
      uploadName = uploadName.replaceAll('_', ' ');
      uploadName = uploadName.slice(0, -1)

      if(certsOnly && (uploadName != 'pdf upload' || uploadName != 'pdf 2 upload')){return null}
      if(!certsOnly && (uploadName == 'pdf upload' || uploadName == 'pdf 2 upload')){return null}
      if(uploadName == 'pdf upload'){ uploadName = 'view certificate'; }
      if(uploadName == 'pdf 2 upload'){ uploadName = 'view 2nd certificate'; }

      if(isMissing){ return null; }

      return (
        <div key={index} className="col-md-6 col-lg-4 info-invoice">
          <h5 className="sub" style={{textTransform: 'capitalize'}}>{uploadName}</h5>
          <p>
            {isMissing ? <span>N/A</span> :
            <a href={getUploadPath(data, true)} target="_blank" rel="noopener noreferrer">(Click To View)</a>}
          </p>
        </div>
      );
    }));

  const populateTable = (fieldData, formData, keyIndex) => {
    if (!formData) { return null }

    console.log('X\n', fieldData, 'FormData\n', formData)
    // Ensure formData is an array of Objects
    if (typeof formData == 'string') {
      formData = [JSON.parse(formData)]
    }

    // Handle Associated Objects using table format
    if (fieldData.assoc_obj) {
      const newObj = {}
      
      fieldData.columns.forEach(element => {
        newObj[element.name] = formData[element.name]
      })

      console.log(newObj)
      const formDataArr = [newObj]
      formData = formDataArr
    }

    // console.log('FIELD DATA\n', fieldData, 'FORM DATA\n', formData)
    const tableHeaders = fieldData.columns.map(th => th)
    const tableHeadersJSX = fieldData.columns.map((th, index) => (
      <th key={index} style={{textTransform: 'capitalize'}}>
        {(th.label || th.name.replaceAll('_', ' '))}
      </th>
    ))
    // const tableHeaders = Object.keys(td).map(th => (<th style={{textTransform: 'capitalize'}}>{th.replaceAll('_', ' ')}</th>));

    const populateTableBody = () => {
      return formData.map((tr, index) => (
        <tr key={index}>
          {/* {console.log('TR\n', tr)} */}
          {tableHeaders.map((td, index) => {
            // console.log('TD\n', td)
            if (td.type == 'date') {
              return <td key={index}>{tr[td.name].slice(0, tr[td.name].indexOf("T"))}</td>
            } else {
              return <td key={index} style={{textTransform: td['format']}}>{tr[td.name]}</td>
            }
          })}
        </tr>
      ))
    }

    const table = (
      <div key={keyIndex} className="col-md-12 info-invoice">
        <h5 className="sub">{fieldData.label}</h5>
          <table className="table table-striped table-striped-bg-black">
            <thead>
              <tr className="header">
                {tableHeadersJSX}
              </tr>
            </thead>
            <tbody>
              {populateTableBody()}
            </tbody>
          </table>
      </div>
    )

    return table
  }

  const boolToString = (data) => {
    const dataString = data?.toString() || 'N/A';

    if (dataString === 'true') {
      return 'Yes'
    } else if (dataString === 'false') {
      return 'No'
    } else {
      return dataString
    }
  }

  const evaluateHideRule = ({ field_name, value, negate }) => {
    const match = formSelected[field_name] == value;
    return negate ? !match : match;
  }

  const shouldHide = (hide) => {
    if (!hide) { return false }

    if (Array.isArray(hide)) {
      return hide.every(evaluateHideRule)
    } else if (typeof hide == 'object') {
      return evaluateHideRule(hide)
    } else {
      return !!formSelected[hide]
    }
  }

  const fieldsRender = () => {
    return allFields.map((x, index) => {
      // console.log(x, formSelected[x.name]);

      if (shouldHide(x.hide)) {
        return null
      }
      if (typeof x == 'string' && x == '::SPACER') {
        return (
          <br/>
        )
      } else if (typeof x == 'string') {
        return (
          <div key={index} className="col-md-12 info-invoice">
            <h3 className="text-muted" style={{textTransform: 'capitalize'}}>
              {x.replaceAll('::', '')}
            </h3>
          </div>
        )
      }
      if (x.type == 'heading' || x.heading) {
        return (
          <div key={index} className="col-md-12 info-invoice">
            <h3 className="text-muted" style={{textTransform: 'capitalize'}}>
              {x.label || x.name?.replaceAll('_', ' ') || x.heading}
            </h3>
          </div>
        )
      } else if (x.type == 'table') {
        return populateTable(x, formSelected[x.name], index)
      } else if (x.type == 'checkbox') {
        const isChecked = !!formSelected[x.name];
        return (
          <div key={index} className="col-md-6 col-lg-4 info-invoice">
            <h5 className="sub" style={{textTransform: 'capitalize'}}>
              {x.view?.label || x.label || x.name?.replaceAll('_', ' ')}
            </h5>
            <p style={{color: isChecked ? '#1a7f37' : '#d1242f', fontWeight: 'bold', fontSize: '2rem', lineHeight: 1}}>
              {isChecked ? '✓' : '✗'}
            </p>
          </div>
        )
      } else {
        const rawValue = formSelected[x.name];
        const viewKey = String(rawValue);
        const hasViewOption = x.view && typeof x.view == 'object'
          && !['value', 'label', 'element', 'format', 'hide'].includes(viewKey)
          && Object.prototype.hasOwnProperty.call(x.view, viewKey);

        const displayValue = hasViewOption
          ? x.view[viewKey]
          : x.view?.value
            ? (typeof x.view.value == 'function' ? x.view.value(rawValue) : x.view.value)
            : (x.type=='currency' ? '$' + boolToString(rawValue) : boolToString(rawValue));

        return (
          <div key={index} className="col-md-6 col-lg-4 info-invoice">
            <h5 className="sub" style={{textTransform: 'capitalize'}}>
              {x.view?.label || x.label || x.name?.replaceAll('_', ' ')}
            </h5>
            <p style={{textTransform: x.format}}>{displayValue}</p>
          </div>
        )
      }
    })
  }

  const bodyRender = () => {
    const allUploads = populateUploads()?.filter(x => x);
    const displayUploads = allUploads?.length ? allUploads : <div className="col-md-6 col-lg-4 info-invoice">N/A</div>

    return (
      <div className="row">
        {fieldsRender()}
        <div className="col-md-12 info-invoice">
          <h5 className="sub text-muted">Uploads</h5>
        </div>
        {displayUploads}
      </div>
);
  };

  return (
    <div>
      {/* Service Record View Page */}
      <div className="row justify-content-center">
        <div className="col-12 col-lg-10 col-xl-9">
          <div className="row align-items-center">
            <div className="col">
              <h6 className="page-pretitle text-primary font-semibold text-lg">
                {formSelected.payment_status ? 'PAID' : 'UNPAID'}&nbsp; | {formSelected.application_decision}
              </h6>
              <h4 className="page-title">{service.serviceType(formSelected)}</h4>
            </div>
            <div className="col-auto">
              <button className="flex items-center btn custom-btn btn-round ml-auto" onClick={() => setFormSelected(null)}>
              <span>Back</span>
              </button>
            </div>
            <div className="col-auto">
              <button className="flex items-center btn btn-round ml-auto">
                <Menu
                menuButton={
                <div className='btn custom-btn'>
                  <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 448 512" height="18" width="18" xmlns="http://www.w3.org/2000/svg">
                    <path d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"></path>
                  </svg>
                  <span data-action>Actions</span>
                </div>
                }
                transition
                portal
                arrow
                >
                {
                  () => methods.map((action, index) => (
                      <MenuItem key={index} onClick={action.fn(formSelected)}>
                        {action.label}
                      </MenuItem>
                      ))
                }
                </Menu>
                &nbsp;&nbsp;&nbsp;&nbsp;
              </button>
            </div>
          </div>
          <div className="page-divider">
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card card-invoice">
                <div className="card-header">
                  <div className="invoice-header">
                    <div className="invoice-logo">
                      <img src="/static/media/bs-coat-of-arms.bb54f8a8.png" alt="Bahamas Coat of Arms"/>
                    </div>
                    <h3 className="invoice-title lg:text-right">Application</h3>
                  </div>
                </div>
                <div className="card-body">
                  <div className="separator-solid"></div>
                  <div className="row">
                    <div className="col-md-4 info-invoice">
                      <h5 className="sub">Application ID</h5>
                      <p>{formSelected.form_num}</p>
                    </div>
                    <div className="col-md-4 info-invoice">
                      <h5 className="sub">Application Date</h5>
                      <p>{formSelected.created_at.slice(0, formSelected.created_at.indexOf("T"))}</p>
                    </div>
                    <div className="col-md-4 info-invoice">
                      <h5 className="sub">Application Status</h5>
                      <p style={{textTransform: 'uppercase'}}>{formSelected.application_decision ? 'pending' : 'emailed'}</p>
                    </div>
                  </div>
                  <div className="separator-solid"></div>
                  <div className="row">
                    <div className="col-md-4 info-invoice">
                      <h5 className="sub">Applicant Name</h5>
                      <div style={{textTransform: 'capitalize'}}>{`${formSelected.user.first_name} ${formSelected.user.middle_name} ${formSelected.user.last_name}`}</div>
                    </div>
                    <div className="col-md-4 info-invoice">
                      <h5 className="sub">Citizenship</h5>
                      <div style={{textTransform: 'capitalize'}}>{formSelected.user.country_of_citizenship}</div>
                    </div>
                    <div className="col-md-4 info-invoice">
                      <h5 className="sub">NIB #</h5>
                      <div>{formSelected.user.NIB}</div>
                    </div>
                    {
                      formSelected.user?.passport_number && (
                        <div className="col-md-4 info-invoice">
                          <h5 className="sub">Passport #</h5>
                          <div>{formSelected.user?.passport_number}</div>
                        </div>
                      )
                    }
                    {
                      formSelected.user?.drivers_license_number	&& (
                        <div className="col-md-4 info-invoice">
                          <h5 className="sub">Driver's Licence #</h5>
                          <div>{formSelected.user?.drivers_license_number}</div>
                        </div>
                      )
                    }
                    {
                      formSelected.user?.voters_card_number	&& (
                        <div className="col-md-4 info-invoice">
                          <h5 className="sub">Voter's Card #</h5>
                          <div>{formSelected.user?.voters_card_number}</div>
                        </div>
                      )
                    }
                    <div className="col-md-4 info-invoice">
                      <h5 className="sub">D.O.B</h5>
                      <div>{formSelected.user.date_of_birth}</div>
                    </div>
                    <div className="col-md-4 info-invoice">
                      <h5 className="sub">Email</h5>
                      <div>{formSelected.user.email}</div>
                    </div>
                    <div className="col-md-4 info-invoice">
                      <h5 className="sub">Mobile Number</h5>
                      <div>{formSelected.user?.additional_phone_number || formSelected.phone_number}</div>
                    </div>
                    <div className="col-md-4 info-invoice">
                      <h5 className="sub">Address</h5>
                      <div>
                        <address>{formSelected.user?.home_address?.street}<br/>{formSelected.user?.home_address?.p_o_box}<br/>{formSelected.user?.home_address?.island}, Bahamas</address>
                      </div>
                    </div>
                  </div>
                  <div className="separator-solid"></div>
                  {bodyRender()}
                </div>
                <div className="card-footer">
                  <div className="row">
                    <div className="col-sm-7 col-md-5 mb-3 mb-md-0 transfer-to"></div>
                    <div className="col-sm-5 col-md-7 transfer-total">
                      <h5 className="sub">Total Amount</h5>
                      <div className="price">${formSelected.payment_amount ? parseFloat(formSelected.payment_amount).toFixed(2) : '0.00'}</div>
                      <span>Taxes Included</span>
                    </div>
                  </div>
                  <div className="separator-solid"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BatchFormView;
